/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimOrganization } from './ClaimOrganization';
import {
    ClaimOrganizationFromJSON,
    ClaimOrganizationFromJSONTyped,
    ClaimOrganizationToJSON,
    ClaimOrganizationToJSONTyped,
} from './ClaimOrganization';
import type { ClaimOrganizationsResponseMeta } from './ClaimOrganizationsResponseMeta';
import {
    ClaimOrganizationsResponseMetaFromJSON,
    ClaimOrganizationsResponseMetaFromJSONTyped,
    ClaimOrganizationsResponseMetaToJSON,
    ClaimOrganizationsResponseMetaToJSONTyped,
} from './ClaimOrganizationsResponseMeta';

/**
 * 
 * @export
 * @interface ClaimOrganizationsResponse
 */
export interface ClaimOrganizationsResponse {
    /**
     * 
     * @type {Array<ClaimOrganization>}
     * @memberof ClaimOrganizationsResponse
     */
    claimOrganizations: Array<ClaimOrganization>;
    /**
     * 
     * @type {ClaimOrganizationsResponseMeta}
     * @memberof ClaimOrganizationsResponse
     */
    meta: ClaimOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ClaimOrganizationsResponse interface.
 */
export function instanceOfClaimOrganizationsResponse(value: object): value is ClaimOrganizationsResponse {
    if (!('claimOrganizations' in value) || value['claimOrganizations'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ClaimOrganizationsResponseFromJSON(json: any): ClaimOrganizationsResponse {
    return ClaimOrganizationsResponseFromJSONTyped(json, false);
}

export function ClaimOrganizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimOrganizationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimOrganizations': ((json['claimOrganizations'] as Array<any>).map(ClaimOrganizationFromJSON)),
        'meta': ClaimOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ClaimOrganizationsResponseToJSON(json: any): ClaimOrganizationsResponse {
    return ClaimOrganizationsResponseToJSONTyped(json, false);
}

export function ClaimOrganizationsResponseToJSONTyped(value?: ClaimOrganizationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimOrganizations': ((value['claimOrganizations'] as Array<any>).map(ClaimOrganizationToJSON)),
        'meta': ClaimOrganizationsResponseMetaToJSON(value['meta']),
    };
}

